import { SelectorCountry } from './modules/main/models/selector-country.model';

export const countries = [
  {
    code: 'AFG',
    name: 'Afghanistan',
  },
  {
    code: 'ALB',
    name: 'Albania',
  },
  {
    code: 'DZA',
    name: 'Algeria',
  },
  {
    code: 'AGO',
    name: 'Angola',
  },
  {
    code: 'ARG',
    name: 'Argentina',
  },
  {
    code: 'ARM',
    name: 'Armenia',
  },
  {
    code: 'AUS',
    name: 'Australia',
  },
  {
    code: 'AUT',
    name: 'Austria',
    subnational: [
      {
        code: 'AT11',
        name: 'Burgenland',
      },
      {
        code: 'AT12',
        name: 'Niederosterreich',
      },
      {
        code: 'AT13',
        name: 'Wien',
      },
      {
        code: 'AT21',
        name: 'Karnten',
      },
      {
        code: 'AT22',
        name: 'Steiermark',
      },
      {
        code: 'AT31',
        name: 'Oberosterreich',
      },
      {
        code: 'AT32',
        name: 'Salzburg',
      },
      {
        code: 'AT33',
        name: 'Tirol',
      },
      {
        code: 'AT34',
        name: 'Vorarlberg',
      },
    ],
  },
  {
    code: 'AZE',
    name: 'Azerbaijan',
  },
  {
    code: 'BHR',
    name: 'Bahrain',
  },
  {
    code: 'BGD',
    name: 'Bangladesh',
  },
  {
    code: 'BRB',
    name: 'Barbados',
  },
  {
    code: 'BLR',
    name: 'Belarus',
  },
  {
    code: 'BEL',
    name: 'Belgium',
    subnational: [
      {
        code: 'BE23',
        name: 'Prov. Oost-Vlaanderen',
      },
      {
        code: 'BE24',
        name: 'Prov. Vlaams-Brabant',
      },
      {
        code: 'BE25',
        name: 'Prov. West-Vlaanderen',
      },
      {
        code: 'BE31',
        name: 'Prov. Brabant Wallon',
      },
      {
        code: 'BE32',
        name: 'Prov. Hainaut',
      },
      {
        code: 'BE33',
        name: 'Prov. Liège',
      },
      {
        code: 'BE34',
        name: 'Prov. Luxembourg (BE)',
      },
      {
        code: 'BE35',
        name: 'Prov. Namur',
      },
      {
        code: 'BE10',
        name: 'Bruxelles Capitale',
      },
      {
        code: 'BE21',
        name: 'Prov. Antwerpen',
      },
      {
        code: 'BE22',
        name: 'Prov. Limburg (BE)',
      },
    ],
  },
  {
    code: 'BLZ',
    name: 'Belize',
  },
  {
    code: 'BEN',
    name: 'Benin',
  },
  {
    code: 'BTN',
    name: 'Bhutan',
  },
  {
    code: 'BOL',
    name: 'Bolivia',
    altNames: ['Plurinational State of Bolivia'],
  },
  {
    code: 'BIH',
    name: 'Bosnia and Herzegovina',
    altNames: ['Bosnia & Herzegovina'],
  },
  {
    code: 'BWA',
    name: 'Botswana',
  },
  {
    code: 'BRA',
    name: 'Brazil',
  },
  {
    code: 'BRN',
    name: 'Brunei',
  },
  {
    code: 'BGR',
    name: 'Bulgaria',
  },
  {
    code: 'BFA',
    name: 'Burkina Faso',
  },
  {
    code: 'BDI',
    name: 'Burundi',
  },
  {
    code: 'KHM',
    name: 'Cambodia',
  },
  {
    code: 'CMR',
    name: 'Cameroon',
  },
  {
    code: 'CAN',
    name: 'Canada',
  },
  {
    code: 'CPV',
    name: 'Cape Verde',
  },
  {
    code: 'CAF',
    name: 'Central African Republic',
  },
  {
    code: 'TCD',
    name: 'Chad',
  },
  {
    code: 'CHL',
    name: 'Chile',
  },
  {
    code: 'CHN',
    name: 'China',
  },
  {
    code: 'COL',
    name: 'Colombia',
  },
  {
    code: 'COM',
    name: 'Comoros',
  },
  {
    code: 'CRI',
    name: 'Costa Rica',
  },
  {
    code: 'HRV',
    name: 'Croatia',
  },
  {
    code: 'CUB',
    name: 'Cuba',
  },
  {
    code: 'CYP',
    name: 'Cyprus',
  },
  {
    code: 'CZE',
    name: 'Czech Republic',
    subnational: [
      {
        code: 'CZ07',
        name: 'Střední Morava',
      },
      {
        code: 'CZ08',
        name: 'Moravskoslezsko',
      },
      {
        code: 'CZ01',
        name: 'Praha',
      },
      {
        code: 'CZ02',
        name: 'Střední Čechy',
      },
      {
        code: 'CZ03',
        name: 'Jihozápad',
      },
      {
        code: 'CZ04',
        name: 'Severozápad',
      },
      {
        code: 'CZ05',
        name: 'Severovýchod',
      },
      {
        code: 'CZ06',
        name: 'Jihovýchod',
      },
    ],
  },
  {
    code: 'COD',
    name: 'Democratic Republic of the Congo',
    altNames: ['DRC', 'D.R.C.', 'D. R. C.', 'Zaire'],
  },
  {
    code: 'DNK',
    name: 'Denmark',
    subnational: [
      {
        code: 'DK01',
        name: 'Hovedstaden',
      },
      {
        code: 'DK02',
        name: 'Sjælland',
      },
      {
        code: 'DK03',
        name: 'Syddanmark',
      },
      {
        code: 'DK04',
        name: 'Midtjylland',
      },
      {
        code: 'DK05',
        name: 'Nordjylland',
      },
    ],
  },
  {
    code: 'DJI',
    name: 'Djibouti',
  },
  {
    code: 'DOM',
    name: 'Dominican Republic',
  },
  {
    code: 'TLS',
    name: 'East Timor',
  },
  {
    code: 'ECU',
    name: 'Ecuador',
  },
  {
    code: 'EGY',
    name: 'Egypt',
  },
  {
    code: 'SLV',
    name: 'El Salvador',
  },
  {
    code: 'GNQ',
    name: 'Equatorial Guinea',
  },
  {
    code: 'ERI',
    name: 'Eritrea',
  },
  {
    code: 'EST',
    name: 'Estonia',
  },
  {
    code: 'SWZ',
    name: 'eSwatini',
  },
  {
    code: 'ETH',
    name: 'Ethiopia',
  },
  {
    code: 'FJI',
    name: 'Fiji',
  },
  {
    code: 'FIN',
    name: 'Finland',
    subnational: [
      {
        code: 'FI19',
        name: 'Länsi-Suomi',
      },
      {
        code: 'FI1B',
        name: 'Helsinki-Uusimaa',
      },
      {
        code: 'FI1C',
        name: 'Etelä-Suomi',
      },
      {
        code: 'FI1D',
        name: 'Pohjois- ja Itä-Suomi',
      },
    ],
  },
  {
    code: 'FRA',
    name: 'France',
    subnational: [
      {
        code: 'FR30',
        name: 'Nord - Pas-de-Calais',
      },
      {
        code: 'FR41',
        name: 'Lorraine',
      },
      {
        code: 'FR42',
        name: 'Alsace',
      },
      {
        code: 'FR43',
        name: 'Franche-Comté',
      },
      {
        code: 'FR51',
        name: 'Pays de la Loire',
      },
      {
        code: 'FR10',
        name: 'Île de France',
      },
      {
        code: 'FR21',
        name: 'Champagne-Ardenne',
      },
      {
        code: 'FR22',
        name: 'Picardie',
      },
      {
        code: 'FR23',
        name: 'Haute-Normandie',
      },
      {
        code: 'FR24',
        name: 'Centre',
      },
      {
        code: 'FR25',
        name: 'Basse-Normandie',
      },
      {
        code: 'FR26',
        name: 'Bourgogne',
      },
      {
        code: 'FR52',
        name: 'Bretagne',
      },
      {
        code: 'FR61',
        name: 'Aquitaine',
      },
      {
        code: 'FR62',
        name: 'Midi-Pyrénées',
      },
      {
        code: 'FR63',
        name: 'Limousin',
      },
      {
        code: 'FR71',
        name: 'Rhône-Alpes',
      },
      {
        code: 'FR72',
        name: 'Auvergne',
      },
      {
        code: 'FR81',
        name: 'Languedoc-Roussillon',
      },
      {
        code: 'FR82',
        name: "Provence-Alpes-Côte d'Azur",
      },
      {
        code: 'FR53',
        name: 'Poitou-Charentes',
      },
      {
        code: 'FR83',
        name: 'Corse',
      },
    ],
  },
  {
    code: 'GAB',
    name: 'Gabon',
  },
  {
    code: 'GMB',
    name: 'Gambia',
  },
  {
    code: 'GEO',
    name: 'Georgia',
  },
  {
    code: 'DEU',
    name: 'Germany',
    subnational: [
      {
        code: 'DE50',
        name: 'Bremen',
      },
      {
        code: 'DE60',
        name: 'Hamburg',
      },
      {
        code: 'DE71',
        name: 'Darmstadt/Frankfurt',
      },
      {
        code: 'DE72',
        name: 'Gießen',
      },
      {
        code: 'DE73',
        name: 'Kassel',
      },
      {
        code: 'DE80',
        name: 'Mecklenburg-Vorpommern',
      },
      {
        code: 'DE91',
        name: 'Braunschweig',
      },
      {
        code: 'DE92',
        name: 'Hannover',
      },
      {
        code: 'DE93',
        name: 'Lüneburg',
      },
      {
        code: 'DE94',
        name: 'Weser-Ems',
      },
      {
        code: 'DE11',
        name: 'Stuttgart',
      },
      {
        code: 'DE12',
        name: 'Karlsruhe',
      },
      {
        code: 'DE13',
        name: 'Freiburg',
      },
      {
        code: 'DE14',
        name: 'Tübingen',
      },
      {
        code: 'DE21',
        name: 'Oberbayern',
      },
      {
        code: 'DE22',
        name: 'Niederbayern',
      },
      {
        code: 'DE23',
        name: 'Oberpfalz',
      },
      {
        code: 'DE24',
        name: 'Oberfranken',
      },
      {
        code: 'DE25',
        name: 'Mittelfranken',
      },
      {
        code: 'DE26',
        name: 'Unterfranken',
      },
      {
        code: 'DE27',
        name: 'Schwaben',
      },
      {
        code: 'DE30',
        name: 'Berlin',
      },
      {
        code: 'DE40',
        name: 'Brandenburg',
      },
      {
        code: 'DEA1',
        name: 'Düsseldorf',
      },
      {
        code: 'DEA2',
        name: 'Köln',
      },
      {
        code: 'DEA3',
        name: 'Münster',
      },
      {
        code: 'DEA4',
        name: 'Detmold',
      },
      {
        code: 'DEA5',
        name: 'Arnsberg',
      },
      {
        code: 'DEB1',
        name: 'Koblenz',
      },
      {
        code: 'DEB2',
        name: 'Trier',
      },
      {
        code: 'DEB3',
        name: 'Rheinhessen-Pfalz',
      },
      {
        code: 'DEC0',
        name: 'Saarland',
      },
      {
        code: 'DED2',
        name: 'Dresden',
      },
      {
        code: 'DED4',
        name: 'Chemnitz',
      },
      {
        code: 'DED5',
        name: 'Leipzig',
      },
      {
        code: 'DEE0',
        name: 'Sachsen-Anhalt',
      },
      {
        code: 'DEF0',
        name: 'Schleswig-Holstein',
      },
      {
        code: 'DEG0',
        name: 'Thüringen',
      },
    ],
  },
  {
    code: 'GHA',
    name: 'Ghana',
  },
  {
    code: 'GRC',
    name: 'Greece',
    subnational: [
      {
        code: 'EL53',
        name: 'Δυτική Μακεδονία',
      },
      {
        code: 'EL54',
        name: 'Ήπειρος',
      },
      {
        code: 'EL61',
        name: 'Θεσσαλία',
      },
      {
        code: 'EL62',
        name: 'Ιόνια Νησιά',
      },
      {
        code: 'EL63',
        name: 'Δυτική Ελλάδα',
      },
      {
        code: 'EL64',
        name: 'Στερεά Ελλάδα',
      },
      {
        code: 'EL65',
        name: 'Πελοπόννησος',
      },
      {
        code: 'EL30',
        name: 'Aττική',
      },
      {
        code: 'EL41',
        name: 'Βόρειο Αιγαίο',
      },
      {
        code: 'EL42',
        name: 'Νότιο Αιγαίο',
      },
      {
        code: 'EL43',
        name: 'Κρήτη',
      },
      {
        code: 'EL51',
        name: 'Aνατολική Μακεδονία, Θράκη',
      },
      {
        code: 'EL52',
        name: 'Κεντρική Μακεδονία',
      },
    ],
  },
  {
    code: 'GTM',
    name: 'Guatemala',
  },
  {
    code: 'GIN',
    name: 'Guinea',
  },
  {
    code: 'GNB',
    name: 'Guinea Bissau',
  },
  {
    code: 'GUY',
    name: 'Guyana',
  },
  {
    code: 'HTI',
    name: 'Haiti',
  },
  {
    code: 'HND',
    name: 'Honduras',
  },
  {
    code: 'HKG',
    name: 'Hong Kong S.A.R.',
    altNames: ['Hong Kong S. A. R.', 'Hong Kong SAR', 'Hong Kong'],
  },
  {
    code: 'HUN',
    name: 'Hungary',
    subnational: [
      {
        code: 'HU10',
        name: 'Közép-Magyarország',
      },
      {
        code: 'HU21',
        name: 'Közép-Dunántúl',
      },
      {
        code: 'HU22',
        name: 'Nyugat-Dunántúl',
      },
      {
        code: 'HU23',
        name: 'Dél-Dunántúl',
      },
      {
        code: 'HU31',
        name: 'Észak-Magyarország',
      },
      {
        code: 'HU32',
        name: 'Észak-Alföld',
      },
      {
        code: 'HU33',
        name: 'Dél-Alföld',
      },
    ],
  },
  {
    code: 'ISL',
    name: 'Iceland',
  },
  {
    code: 'IND',
    name: 'India',
  },
  {
    code: 'IDN',
    name: 'Indonesia',
  },
  {
    code: 'IRN',
    name: 'Iran',
  },
  {
    code: 'IRQ',
    name: 'Iraq',
  },
  {
    code: 'IRL',
    name: 'Ireland',
    altNames: ['Republic of Ireland'],
    subnational: [
      {
        code: 'IE01',
        name: 'Border, Midland and Western',
      },
      {
        code: 'IE02',
        name: 'Southern and Eastern',
      },
    ],
  },
  {
    code: 'ISR',
    name: 'Israel',
  },
  {
    code: 'ITA',
    name: 'Italy',
    subnational: [
      {
        code: 'ITC1',
        name: 'Piemonte',
      },
      {
        code: 'ITC2',
        name: "Valle d'Aosta/Vallée d'Aoste",
      },
      {
        code: 'ITC3',
        name: 'Liguria',
      },
      {
        code: 'ITG2',
        name: 'Sardegna',
      },
      {
        code: 'ITH1',
        name: 'Provincia Autonoma di Bolzano/Bozen',
      },
      {
        code: 'ITH2',
        name: 'Provincia Autonoma di Trento',
      },
      {
        code: 'ITH3',
        name: 'Veneto',
      },
      {
        code: 'ITH4',
        name: 'Friuli-Venezia Giulia',
      },
      {
        code: 'ITH5',
        name: 'Emilia-Romagna',
      },
      {
        code: 'ITI1',
        name: 'Toscana',
      },
      {
        code: 'ITI2',
        name: 'Umbria',
      },
      {
        code: 'ITI3',
        name: 'Marche',
      },
      {
        code: 'ITI4',
        name: 'Lazio',
      },
      {
        code: 'ITC4',
        name: 'Lombardia',
      },
      {
        code: 'ITF1',
        name: 'Abruzzo',
      },
      {
        code: 'ITF2',
        name: 'Molise',
      },
      {
        code: 'ITF3',
        name: 'Campania',
      },
      {
        code: 'ITF4',
        name: 'Puglia',
      },
      {
        code: 'ITF5',
        name: 'Basilicata',
      },
      {
        code: 'ITF6',
        name: 'Calabria',
      },
      {
        code: 'ITG1',
        name: 'Sicilia',
      },
    ],
  },
  {
    code: 'CIV',
    name: 'Ivory Coast',
    altNames: ["Côte d'Ivoire", 'Cote d’Ivoire'],
  },
  {
    code: 'JAM',
    name: 'Jamaica',
  },
  {
    code: 'JPN',
    name: 'Japan',
  },
  {
    code: 'JOR',
    name: 'Jordan',
  },
  {
    code: 'KAZ',
    name: 'Kazakhstan',
  },
  {
    code: 'KEN',
    name: 'Kenya',
  },
  {
    code: 'KWT',
    name: 'Kuwait',
  },
  {
    code: 'KGZ',
    name: 'Kyrgyzstan',
  },
  {
    code: 'LAO',
    name: 'Laos',
  },
  {
    code: 'LVA',
    name: 'Latvia',
  },
  {
    code: 'LBN',
    name: 'Lebanon',
  },
  {
    code: 'LSO',
    name: 'Lesotho',
  },
  {
    code: 'LBR',
    name: 'Liberia',
  },
  {
    code: 'LBY',
    name: 'Libya',
  },
  {
    code: 'LTU',
    name: 'Lithuania',
  },
  {
    code: 'LUX',
    name: 'Luxembourg',
  },
  {
    code: 'MAC',
    name: 'Macao S.A.R',
  },
  {
    code: 'MKD',
    name: 'Macedonia',
    altNames: ['North Macedonia'],
  },
  {
    code: 'MDG',
    name: 'Madagascar',
  },
  {
    code: 'MWI',
    name: 'Malawi',
  },
  {
    code: 'MYS',
    name: 'Malaysia',
  },
  {
    code: 'MDV',
    name: 'Maldives',
  },
  {
    code: 'MLI',
    name: 'Mali',
  },
  {
    code: 'MLT',
    name: 'Malta',
  },
  {
    code: 'MRT',
    name: 'Mauritania',
  },
  {
    code: 'MUS',
    name: 'Mauritius',
  },
  {
    code: 'MEX',
    name: 'Mexico',
  },
  {
    code: 'MDA',
    name: 'Moldova',
  },
  {
    code: 'MNG',
    name: 'Mongolia',
  },
  {
    code: 'MNE',
    name: 'Montenegro',
  },
  {
    code: 'MAR',
    name: 'Morocco',
  },
  {
    code: 'MOZ',
    name: 'Mozambique',
  },
  {
    code: 'MMR',
    name: 'Myanmar',
  },
  {
    code: 'NAM',
    name: 'Namibia',
  },
  {
    code: 'NPL',
    name: 'Nepal',
  },
  {
    code: 'NLD',
    name: 'Netherlands',
    subnational: [
      {
        code: 'NL11',
        name: 'Groningen',
      },
      {
        code: 'NL12',
        name: 'Friesland (NL)',
      },
      {
        code: 'NL13',
        name: 'Drenthe',
      },
      {
        code: 'NL21',
        name: 'Overijssel',
      },
      {
        code: 'NL22',
        name: 'Gelderland',
      },
      {
        code: 'NL23',
        name: 'Flevoland',
      },
      {
        code: 'NL31',
        name: 'Utrecht',
      },
      {
        code: 'NL32',
        name: 'Noord-Holland',
      },
      {
        code: 'NL33',
        name: 'Zuid-Holland',
      },
      {
        code: 'NL34',
        name: 'Zeeland',
      },
      {
        code: 'NL41',
        name: 'Noord-Brabant',
      },
      {
        code: 'NL42',
        name: 'Limburg (NL)',
      },
    ],
  },
  {
    code: 'NZL',
    name: 'New Zealand',
  },
  {
    code: 'NIC',
    name: 'Nicaragua',
  },
  {
    code: 'NER',
    name: 'Niger',
  },
  {
    code: 'NGA',
    name: 'Nigeria',
  },
  {
    code: 'NOR',
    name: 'Norway',
  },
  {
    code: 'OMN',
    name: 'Oman',
  },
  {
    code: 'PAK',
    name: 'Pakistan',
  },
  {
    code: 'PSE',
    name: 'Palestine',
  },
  {
    code: 'PAN',
    name: 'Panama',
  },
  {
    code: 'PNG',
    name: 'Papua New Guinea',
  },
  {
    code: 'PRY',
    name: 'Paraguay',
  },
  {
    code: 'PER',
    name: 'Peru',
  },
  {
    code: 'PHL',
    name: 'Philippines',
    altNames: ['The Philippines'],
  },
  {
    code: 'POL',
    name: 'Poland',
    subnational: [
      {
        code: 'PL31',
        name: 'Lubelskie',
      },
      {
        code: 'PL32',
        name: 'Podkarpackie',
      },
      {
        code: 'PL33',
        name: 'Swietokrzyskie',
      },
      {
        code: 'PL34',
        name: 'Podlaskie',
      },
      {
        code: 'PL41',
        name: 'Wielkopolskie',
      },
      {
        code: 'PL42',
        name: 'Zachodniopomorskie',
      },
      {
        code: 'PL43',
        name: 'Lubuskie',
      },
      {
        code: 'PL51',
        name: 'Dolnoslaskie',
      },
      {
        code: 'PL52',
        name: 'Opolskie',
      },
      {
        code: 'PL11',
        name: 'Lódzkie',
      },
      {
        code: 'PL61',
        name: 'Kujawsko-Pomorskie',
      },
      {
        code: 'PL62',
        name: 'Warminsko-Mazurskie',
      },
      {
        code: 'PL12',
        name: 'Mazowieckie',
      },
      {
        code: 'PL63',
        name: 'Pomorskie',
      },
      {
        code: 'PL21',
        name: 'Malopolskie',
      },
      {
        code: 'PL22',
        name: 'Slaskie',
      },
    ],
  },
  {
    code: 'PRT',
    name: 'Portugal',
  },
  {
    code: 'PRI',
    name: 'Puerto Rico',
  },
  {
    code: 'QAT',
    name: 'Qatar',
  },
  {
    code: 'COG',
    name: 'Republic of Congo',
    altNames: ['Republic of the Congo'],
  },
  {
    code: 'SRB',
    name: 'Republic of Serbia',
    altNames: ['Serbia'],
  },
  {
    code: 'ROU',
    name: 'Romania',
  },
  {
    code: 'RUS',
    name: 'Russia',
    altNames: ['Russian Federation', 'The Russian Federation'],
  },
  {
    code: 'RWA',
    name: 'Rwanda',
  },
  {
    code: 'LCA',
    name: 'Saint Lucia',
    altNames: ['St Lucia', 'St. Lucia'],
  },
  {
    code: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    altNames: [
      'Saint Vincent & the Grenadines',
      'Saint Vincent',
      'St. Vincent',
      'St Vincent',
      'Grenadines',
    ],
  },
  {
    code: 'WSM',
    name: 'Samoa',
  },
  {
    code: 'STP',
    name: 'Sao Tome and Principe',
    altNames: ['São Tomé and Príncipe'],
  },
  {
    code: 'SAU',
    name: 'Saudi Arabia',
  },
  {
    code: 'SEN',
    name: 'Senegal',
  },
  {
    code: 'SLE',
    name: 'Sierra Leone',
  },
  {
    code: 'SGP',
    name: 'Singapore',
  },
  {
    code: 'SVK',
    name: 'Slovakia',
    subnational: [
      {
        code: 'SK01',
        name: 'Bratislavský kraj',
      },
      {
        code: 'SK02',
        name: 'Západné Slovensko',
      },
      {
        code: 'SK03',
        name: 'Stredné Slovensko',
      },
      {
        code: 'SK04',
        name: 'Východné Slovensko',
      },
    ],
  },
  {
    code: 'SVN',
    name: 'Slovenia',
  },
  {
    code: 'SLB',
    name: 'Solomon Islands',
  },
  {
    code: 'SOM',
    name: 'Somalia',
  },
  {
    code: 'ZAF',
    name: 'South Africa',
  },
  {
    code: 'KOR',
    name: 'South Korea',
  },
  {
    code: 'SSD',
    name: 'South Sudan',
  },
  {
    code: 'ESP',
    name: 'Spain',
    subnational: [
      {
        code: 'ES43',
        name: 'Extremadura',
      },
      {
        code: 'ES51',
        name: 'Cataluña',
      },
      {
        code: 'ES52',
        name: 'Comunidad Valenciana',
      },
      {
        code: 'ES53',
        name: 'Illes Balears',
      },
      {
        code: 'ES61',
        name: 'Andalucía',
      },
      {
        code: 'ES62',
        name: 'Región de Murcia',
      },
      {
        code: 'ES63',
        name: 'Ciudad Autónoma de Ceuta',
      },
      {
        code: 'ES64',
        name: 'Ciudad Autónoma de Melilla',
      },
      {
        code: 'ES70',
        name: 'Canarias',
      },
      {
        code: 'ES11',
        name: 'Galicia',
      },
      {
        code: 'ES12',
        name: 'Principado de Asturias',
      },
      {
        code: 'ES13',
        name: 'Cantabria',
      },
      {
        code: 'ES21',
        name: 'País Vasco',
      },
      {
        code: 'ES22',
        name: 'Comunidad Foral de Navarra',
      },
      {
        code: 'ES23',
        name: 'La Rioja',
      },
      {
        code: 'ES24',
        name: 'Aragón',
      },
      {
        code: 'ES30',
        name: 'Comunidad de Madrid',
      },
      {
        code: 'ES41',
        name: 'Castilla y León',
      },
      {
        code: 'ES42',
        name: 'Castilla-La Mancha',
      },
    ],
  },
  {
    code: 'LKA',
    name: 'Sri Lanka',
  },
  {
    code: 'SDN',
    name: 'Sudan',
  },
  {
    code: 'SUR',
    name: 'Suriname',
  },
  {
    code: 'SWE',
    name: 'Sweden',
    subnational: [
      {
        code: 'SE11',
        name: 'Stockholm',
      },
      {
        code: 'SE12',
        name: 'Östra Mellansverige',
      },
      {
        code: 'SE21',
        name: 'Småland med öarna',
      },
      {
        code: 'SE22',
        name: 'Sydsverige',
      },
      {
        code: 'SE23',
        name: 'Västsverige',
      },
      {
        code: 'SE31',
        name: 'Norra Mellansverige',
      },
      {
        code: 'SE32',
        name: 'Mellersta Norrland',
      },
      {
        code: 'SE33',
        name: 'Övre Norrland',
      },
    ],
  },
  {
    code: 'SYC',
    name: 'Seychelles',
  },
  {
    code: 'SYR',
    name: 'Syria',
  },
  {
    code: 'FSM',
    name: 'Micronesia',
  },
  {
    code: 'CHE',
    name: 'Switzerland',
  },
  {
    code: 'TWN',
    name: 'Taiwan',
  },
  {
    code: 'TJK',
    name: 'Tajikistan',
  },
  {
    code: 'THA',
    name: 'Thailand',
  },
  {
    code: 'BHS',
    name: 'The Bahamas',
  },
  {
    code: 'TGO',
    name: 'Togo',
  },
  {
    code: 'TON',
    name: 'Tonga',
  },
  {
    code: 'TTO',
    name: 'Trinidad and Tobago',
    altNames: ['Trinidad & Tobago'],
  },
  {
    code: 'TUN',
    name: 'Tunisia',
  },
  {
    code: 'TUR',
    name: 'Turkey',
  },
  {
    code: 'TKM',
    name: 'Turkmenistan',
  },
  {
    code: 'UGA',
    name: 'Uganda',
  },
  {
    code: 'UKR',
    name: 'Ukraine',
  },
  {
    code: 'ARE',
    name: 'United Arab Emirates',
    altNames: ['UAE', 'U.A.E.', 'U. A. E.'],
  },
  {
    code: 'GBR',
    name: 'United Kingdom',
    altNames: ['UK', 'U. K.', 'U.K.', 'Great Britain', 'GB', 'G. B.', 'G.B.'],
    subnational: [
      {
        code: 'UKC1',
        name: 'Tees Valley and Durham',
      },
      {
        code: 'UKC2',
        name: 'Northumberland and Tyne and Wear',
      },
      {
        code: 'UKD1',
        name: 'Cumbria',
      },
      {
        code: 'UKD3',
        name: 'Greater Manchester',
      },
      {
        code: 'UKD4',
        name: 'Lancashire',
      },
      {
        code: 'UKD6',
        name: 'Cheshire',
      },
      {
        code: 'UKD7',
        name: 'Merseyside',
      },
      {
        code: 'UKE1',
        name: 'East Yorkshire and Northern Lincolnshire',
      },
      {
        code: 'UKE2',
        name: 'North Yorkshire',
      },
      {
        code: 'UKE3',
        name: 'South Yorkshire',
      },
      {
        code: 'UKM6',
        name: 'Highlands and Islands',
      },
      {
        code: 'UKK1',
        name: 'Gloucestershire, Wiltshire and Bristol/Bath area',
      },
      {
        code: 'UKK2',
        name: 'Dorset and Somerset',
      },
      {
        code: 'UKK3',
        name: 'Cornwall and Isles of Scilly',
      },
      {
        code: 'UKK4',
        name: 'Devon',
      },
      {
        code: 'UKL1',
        name: 'West Wales and The Valleys',
      },
      {
        code: 'UKL2',
        name: 'East Wales',
      },
      {
        code: 'UKM5',
        name: 'North Eastern Scotland',
      },
      {
        code: 'UKM7',
        name: 'Eastern Scotland',
      },
      {
        code: 'UKM8',
        name: 'West Central Scotland',
      },
      {
        code: 'UKM9',
        name: 'Southern Scotland',
      },
      {
        code: 'UKN0',
        name: 'Northern Ireland',
      },
      {
        code: 'UKE4',
        name: 'West Yorkshire',
      },
      {
        code: 'UKF1',
        name: 'Derbyshire and Nottinghamshire',
      },
      {
        code: 'UKF2',
        name: 'Leicestershire, Rutland and Northamptonshire',
      },
      {
        code: 'UKF3',
        name: 'Lincolnshire',
      },
      {
        code: 'UKG1',
        name: 'Herefordshire, Worcestershire and Warwickshire',
      },
      {
        code: 'UKG2',
        name: 'Shropshire and Staffordshire',
      },
      {
        code: 'UKG3',
        name: 'West Midlands',
      },
      {
        code: 'UKH1',
        name: 'East Anglia',
      },
      {
        code: 'UKH2',
        name: 'Bedfordshire and Hertfordshire',
      },
      {
        code: 'UKH3',
        name: 'Essex',
      },
      {
        code: 'UKI3',
        name: 'Inner London - West',
      },
      {
        code: 'UKI4',
        name: 'Inner London - East',
      },
      {
        code: 'UKI5',
        name: 'Outer London - East and North East',
      },
      {
        code: 'UKI6',
        name: 'Outer London - South',
      },
      {
        code: 'UKI7',
        name: 'Outer London - West and North West',
      },
      {
        code: 'UKJ1',
        name: 'Berkshire, Buckinghamshire and Oxfordshire',
      },
      {
        code: 'UKJ2',
        name: 'Surrey, East and West Sussex',
      },
      {
        code: 'UKJ3',
        name: 'Hampshire and Isle of Wight',
      },
      {
        code: 'UKJ4',
        name: 'Kent',
      },
    ],
  },
  {
    code: 'TZA',
    name: 'United Republic of Tanzania',
    altNames: ['Tanzania'],
  },
  {
    code: 'USA',
    name: 'United States of America',
    altNames: ['USA', 'U.S.A.', 'U. S. A.'],
  },
  {
    code: 'URY',
    name: 'Uruguay',
  },
  {
    code: 'UZB',
    name: 'Uzbekistan',
  },
  {
    code: 'VUT',
    name: 'Vanuatu',
  },
  {
    code: 'VEN',
    name: 'Venezuela',
  },
  {
    code: 'VNM',
    name: 'Vietnam',
  },
  {
    code: 'YEM',
    name: 'Yemen',
  },
  {
    code: 'ZMB',
    name: 'Zambia',
  },
  {
    code: 'ZWE',
    name: 'Zimbabwe',
  },
];

export const countriesMap: Map<string, SelectorCountry> = countries.reduce(
  (initial, current) => initial.set(current.code, current),
  new Map()
);
